import React, { useEffect, useRef } from "react";
import { Fragment, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { ChartBarIcon, ChartBarSquareIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import Avatar from "react-avatar-edit";
import Tooltip from "../Small Components/tooltip";
import { CheckIcon } from "@heroicons/react/20/solid";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { Bars3Icon, BellIcon } from "@heroicons/react/24/outline";

import { Routes, Route, useNavigate } from "react-router-dom";

import Papa from "papaparse";
import {
  CloudArrowDownIcon,
  ListBulletIcon,
  DocumentTextIcon,
  IdentificationIcon,
  CreditCardIcon,
  PaperAirplaneIcon,
  UserPlusIcon,
  PencilIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import moment from "moment";
import Tag from "../Tag/Tag";
import { useFormik } from "formik";
import IdCardAll from "../All ID Card/IdCardAll";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Done from "../Alerts/Done";
import NotFound from "../Alerts/NotFound";
import CustomCertificate from "../Certificate/CustomCertificate";
import Skeleton from "react-loading-skeleton";
import ExportCSV from "../OperationsDashboard/ExportCSV";
import { Toaster, toast } from "sonner";
import axiosCacheAdapter from "axios-cache-adapter";
import Delegate from "./Guest/Guests";
import Registration from "./Registration";
import Observers from "./Observers/Observers";
import LocalTeamMember from "./LocalTeam/LocalTeamMember";
import Guests from "./Guest/Guests";
import CoreTeamMember from './CoreTeam/CoreTeamMember';
import Analytics from './Analytic/Analytics';



var userEmail;
  var JSToken;
  var accessToken;
  if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };


const RegistrationdNavBar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [onFilters, setOnFilters] = useState(false);
  const { eventID } = useParams();
  const HotelMember = [
    {
      name: "Diplomats",
      href: `all-registrations/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Guests",
      href: `guests/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Local Team ",
      href: `local-team-member/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Core Team ",
      href: `core-team-member/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
    // {
    //   name: "Observers",
    //   href: `observers/${eventID}`,
    //   icon: ListBulletIcon,
    //   current: false,
    // },
  ];
  const Insight = [
    { name: "Insights", href: `analytics/${eventID}`,  current: false },
   
  ];
  const [
    currentNavigationOperationHotelMember,
    setCurrentNavigationOperationHotelMember,
  ] = useState(HotelMember);
  const [ currentNavigationInsight, setCurrentNavigationInsight,] = useState(Insight);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }




  const handleClickNavigationHotelMember = (index, setCurrentNavigationOperationHotelMember) => {
    const updatedNavigation = currentNavigationOperationHotelMember.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigationOperationHotelMember(updatedNavigation);
    // localStorage.setItem('activeNavigationIndex', index.toString());
  };
  
  useEffect(() => {
    const path = window.location.pathname;
    const updatedNavigation = currentNavigationOperationHotelMember.map((item) => {
      if (path.includes(item.href)) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    const hasCurrentItem = updatedNavigation.some((item) => item.current);
    if (!hasCurrentItem) {
      updatedNavigation[0].current = true;
    }

    setCurrentNavigationOperationHotelMember(updatedNavigation);
  }, []);





  // const handleClickNavigationHotelMember = (index) => {
  //   const updatedNavigation = currentNavigationOperationHotelMember.map(
  //     (item, i) => {
  //       return {
  //         ...item,
  //         current: i === index, // Set the first item as the default active item
  //       };
  //     }
  //   );
  //   setCurrentNavigationOperationHotelMember(updatedNavigation);
  // };
  const handleClickNavigationinsight = (index) => {
    const updatedNavigation = currentNavigationInsight.map(
      (item, i) => {
        if (i === index) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      }
    );
    setCurrentNavigationInsight(updatedNavigation);
  };

  const [nationalitiesToCsv, setNationalitiesToCsv] = useState();

  const [onNtionality, setOnNtionality] = useState(false);
  const [apiFilters, setApiFilters] = useState(`["event","=","${eventID}"]`);
  const [allEventSuspend, setAllEventSuspend] = useState([]);
 
  useEffect(() => {
    
    const fetchEventRegisteration = async () => {
      try {
        const result = await axios.get(
            `https://dash.bestdiplomats.org/api/method/taken-countries?event=${eventID}`,
            config
          )
          .then((response) => {
            let mySet = new Set();
            // console.log("response data",response.data.data.length);
            response.data.data.forEach((person) =>
              mySet.add(person.nationality)
            );
            setAllEventSuspend(response.data.data);
            let arrayOfNationalities = [];
            mySet.forEach((item) =>
            arrayOfNationalities.push({ Country: item })
            );
          
            
          });
      } catch (e) {
        console.log(e);
      
      }
    };
    fetchEventRegisteration();
  }, []);
  // console.log("taken country",allEventSuspend);

  const newArray = [];
  const [uniqueAllEventSuspended, setuniqueAllEventSuspended] = useState([])

useEffect(() => {
  if(eventID=="13e40291a0"){

    setuniqueAllEventSuspended([ "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Aruba", "Australia", "Austria",
    "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda",
    "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
    "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia",
    "Comoros", "Congo, The Democratic Republic of The", "Republic of the Congo", "Costa Rica", "Côte d'Ivoire", "Croatia",
    "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
    "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia",
    "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-bissau", "Guyana", "Haiti",
    "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
    "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "North Korea", "South Korea",
    "Kuwait", "Kosovo", "Lao People's Democratic Republic", "Kyrgyzstan", "Latvia", "Lebanon", "Lesotho", "Liberia",
    "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia, The Former Yugoslav Republic of", "Madagascar",
    "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico",
    "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
    "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway",
    "North Macedonia", "Oman", "Pakistan", "Palau", "Palestinian Territories", "Panama", "Papua New Guinea", "Paraguay",
    "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
    "Saint Lucia", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Swaziland","Serbia", "Seychelles",
    "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka",
    "Scotland", "Sudan", "South Sudan", "Suriname", "Sweden", "Switzerland", "Syrian Arab Republic",
    "Taiwan (ROC)", "Tajikistan", "Tanzania", "Thailand", "Timor-leste", "Togo", "Tokelau", "Republic of Somaliland",
    "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates",
    "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Yemen", "Zambia",
    "Zimbabwe", "International Observer", "Ambassador", "Diplomatic Experts", "Local Team Registration Members",
    "Ambassadors", "Speakers and Guest of Honours", "International Observers", "Volunteers", "Shell PLC", "Greenpeace",
    "Chevron", "Exxon", "British Petroleum", "Gazprom", "Coal India", "Saudi Aramco", "Total SA", "Iraq national Oil Co.",
    "Kuwait Petroleum Corp", "Clean Air Fund", "Majid Al Futtaim", "Abu Dhabi National Oil (ADNOC)", "YoungO", "Amnesty International",
    "CERES", "Doctors without borders", "Oxfam", "Apple", "Microsoft", "Amazon", "Facebook", "Google", "YouTube", "IBM", "Open AI",
    "Nvidia", "EFF Electronic Frontier Foundation", "Not Selected", "Director General", "Communication Manager",
    "Communication Executive", "Head of Operations", "Academics", "Tech Team One", "Tech Team Two", "Conference Coordinator",
    "Conference Manager", "Diplomatic Expert", "Volunteer", "Asabe Shehu Yar'Adua Foundation (ASYARF)", "Benetech", "CBR Global Network",
    "Communities Forestry and Social Development Organization Communications", "Data Pop Alliance", "Design Bangladesh",
    "Electronic Frontier Foundation (EFF)", "Essl Foundation", "Franklin & Eleasnor Roosevelt Institute",
    "Friends of Peace and Development Organization", "G3ict Global Initiative for Inclusive Technologies",
    "Global Alliance on Accessible Technologies and Environment (GAATES)", "Harmony of the World", "Human Rights Watch",
    "Landmine Survivors Network", "New World Hope Organization", "Orange Penguin Foundation", "Save The Children", "Scope",
    "Solar Cookers International", "World Future Council Foundation", "World Policy Analysis Center", "Arab Office of Youth and Environment",
    "American Forum for Global Education", "Arab Urban Development Institute", "Asia Pacific Forum on Women, Law and Development",
    "Asian and Pacific Development Center (APDC)", "Asian Students Association", "Business Council of Australia",
    "Caribbean Policy Development Centre Inc.", "Center for Environmental Studies and Research",
    "Center for International Environmental Law (CIEL)", "Center for the Study of Women and Society",
    "Center for Respect of Life and Environment", "Centre for Environment and Development",
    "Centre for Research, Planning and Action", "Centre for Research on Sustainable Agricultural and Rural Development",
    "Centre for International Environmental Law", "Environmental Investigation Agency",
    "Environmental Law Centre (Alberta)", "Environment and Rural Development Foundation",
    "European Center of Environmental Studies", "African Youth Network for Sustainable Development",
    "All China Youth Federation (ACFY)", "Arab NGO Network for Development",
    "Asia Pacific Environmental Connection of Sociologist", "Association for Human Rights and Democracy in Africa",
    "Association For Sustainable Human Development", "Association for Protection of Environment and Culture",
    "Association for Research on Climate and Environment", "Association for the Protection of the Environment (APE)",
    "Bahrain Youth and Environment Society", "Brazilian Forum on Climate Change", "British Columbia Environmental Network",
    "Business Council for Sustainable Energy", "Business for Social Responsibility", "Center for Community Development Studies",
    "Center for Energy and Environmental Policy", "CENTRE FOR DEVELOPMENT AND CIVIC EDUCATION",
    "Centre for Environmental Training and Information", "Centre for Rural Development Systems", "Children of the Earth",
    "China Economic and Social Council (CESC)", "Clean Air Foundation", "Council for International Development",
    "Council for Scientific and Industrial Research", "European Network of Women", "European Policies Research Centre",
    "Global Environmental Management Education Center", "Human Development Center", "Human Rights Information Network",
    "Institute for Global Environmental Strategies", "Institute of Policy Studies",
    "Institute of Sustainable Development and Management of Natural Resources", "International Development Center",
    "International Movement for Peace and Sustainable Development", "Japan Youth Ecology League", "Leadership Watch",
    "Youth for Development and Cooperation", "Youth Enhancement Organization", "Worldwatch Institute",
    "World Women Parliamentarians for Peace (WWPP)", "World Peace Council", "Youth Program For The Development Of Africa",
    "World Sustainable Agriculture Association", "World Economy, Ecology and Development",
    "Women's International Policy Action Committee on Environment and Development",
    "Women and Environment Education and Development Foundation",
    "United Socio-Economic Development and Research Programme", "UNED - United Kingdom (UN Environment and Development Committee)",
    "Sustainable Development Policy Institute", "Stockholm Environment Institute", "Society for Rural Development",
    "Society for International Development", "Rural Development Youth Training Institute", "Overseas Development Council, The",
    "One World Now, Inc", "Pacific Energy and Resources Center", "International Synergy Institute",
    "International Youth Federation for Environmental Studies and Conservation",
    "International Society for Environmental Ethics", "International Court of the Environment", "Global Climate Coalition",
    "Green Earth Organization", "Global Commons Institute", "Friends of the Environment", "Environmental Protection Society","Action for Development (ACFODE)",
    "American Society of International Law",
    "Australian Council for International Development",
    "Caribbean Network for Integrated Rural Development",
    "Centre for Culture and Development",
    "Centre for Development of International Law",
    "Centre for Science and Environment",
    "Climate Council",
    "Cooperation for Peace, Sweden",
    "Council for Human Ecology Kenya (CHEK)",
    // add new country 28
    "Earth Light Network Inc",
    "Earth Savers Movement Inc",
    "Economists for Peace and Security",
    "Educators for Peace, Norway",
    "Environmental Business Council",
    "European Youth Forest Action",
    "Global Energy Network International",
      // add new country 08-01-2024
  "Walmart",
  "Exxon Mobil",
  "McKesson",
  "Marathon Petroleum",
  "Valero Energy",
  "Ford Motor",
  "General Motors",
  "JPMorgan Chase",
  "Meta Platforms",
  "Bank of America",
  "Target",
  "Dell Technologies",
  "Archer Daniels Midland",
  "Citigroup",
  "UPS",
  "Pfizer",
  "Johnson & Johnson",
  "FedEx",
  "Freddie Mac",
  "PepsiCo",
  "Walt Disney",
  "ConocoPhillips",
  "Tesla",
  "Procter & Gamble",
  "General Electric",
  "Albertsons",
  "MetLife",
  "Boeing",
  "Intel",
  "HP",
  "Merck",
  "World Kinect",
  "AIG",
  "American Express",
  "Tyson Foods",
  "Cisco Systems",
  "Oracle",
  "Nationwide",
  "Delta Air Lines",
  "American Airlines Group",
  "Nike",
  "United Airlines Holdings",
  "Thermo Fisher Scientific",
  "Abbott Laboratories",
  "Coca-Cola","Nucor",
  "Massachusetts Mutual Life Insurance",
  "TIAA",
  "General Dynamics",
  "Capital One Financial",
  "Arrow Electronics",
  "Occidental Petroleum",
  "Northwestern Mutual",
  "3M",
  "US Foods Holding",
  "Warner Bros. Discovery",
  "Cheniere Energy",
  "Broadcom",
  "Starbucks",
  "Uber Technologies",
  "Philip Morris International",
  "Netflix",
  "NRG Energy",
  "Mondelez International",
  "Paramount Global",
  "Visa",
  "United Natural Foods",
  "Hewlett Packard Enterprise",
  "PayPal Holdings",
  "Nvidia",
  "EOG Resources",
  "Union Pacific",
  "Southwest Airlines",
  "Advanced Micro Devices",
  "McDonald's",
  "Steel Dynamics",
  "Mastercard",
  "PG&E",
  "Baker Hughes",
  "Marriott International",
  "Halliburton",
  "Altria Group",
  "Texas Instruments",
  "Bank of New York Mellon",
  "ManpowerGroup",
  "American Electric Power",
  "Moderna",
  "General Mills",
  "Exelon",
  "PPG Industries",
  "Adobe",
  "Lumen Technologies",
  "Edison International",
  "Quanta Services",
  "Reliance Steel & Aluminum",
  "Thor Industries",
  "Reinsurance Group of America",
  "Discover Financial Services",
  "Baxter International",
  "Laboratory Corp. of America",
  "Jacobs Solutions",
  "Guardian Life Ins. Co. of America",
  "Fidelity National Information Services",
  "Ameriprise Financial",
  "Tractor Supply",
  "Ecolab",
  "Farmers Insurance Exchange",
  "Sonic Automotive"])
  }else{
    setuniqueAllEventSuspended([ "Antigua and Barbuda","Afghanistan",
    "Albania",
    "Aruba",
    "Algeria",
    "Andorra",
    "Angola",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo, The Democratic Republic of The",
    "Republic of the Congo",
    "Costa Rica",
    "Côte d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Eswatini",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-bissau",
    "Guyana",
    "Haiti",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Kosovo",
    "Kiribati",
    "North Korea",
    "South Korea",
    "Lao People's Democratic Republic",
    "Kyrgyzstan",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Macedonia, The Former Yugoslav Republic of",
    "Micronesia, Federated States of",
    "Moldova, Republic of",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "North Macedonia",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Palestinian Territories",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Vincent and the Grenadines",
    "Saint Lucia",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "State of Libya",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "South Sudan",
    "Suriname",
    "Sweden",
    "Swaziland",
    "Switzerland",
    "Syrian Arab Republic",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-leste",
    "Togo",
    "Tuvalu",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Viet Nam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Shell PLC",
    "Greenpeace",
    "Chevron",
    "Exxon",
    "British Petroleum",
    "Gazprom",
    "Coal India",
    "Saudi Aramco",
    "Total SA",
    "Iraq national Oil Co.",
    "Kuwait Petroleum Corp",
    "Clean Air Fund",
    "Majid Al Futtaim",
    "Abu Dhabi National Oil (ADNOC)",
    "YoungO",
    "Amnesty International",
    "CERES",
    "Doctors without borders",
    "Johnson and Johnson",
    "JP Morgan",
    "Oxfam",
    "Nestle",
    "UnitedHealth Group",
    "HSBC",
    "Verizon",
    "BRAC",
    "International Committee of the Red Cross (ICRC)",
    "Apple",
    "Microsoft",
    "Amazon",
    "Facebook",
    "YouTube",
    "Google",
    "EFF Electronic Frontier Foundation",
    "Nvidia",
    "Open AI",
    "Human Rights Watch",
    "IBM" ])
  }
}, [eventID])

let nameCounts = {};

// // Count occurrences of each organization name
uniqueAllEventSuspended?.forEach(organization => {
    nameCounts[organization] = (nameCounts[organization] || 0) + 1;
});

// console.log(nameCounts);
  // const uniqueAllEventSuspended = ["Director General", "Head of Operations","Afghanistan", "Albania","Algeria","Andorra","Angola","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo, The Democratic Republic of The","Republic of the Congo","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-bissau","Guyana","Haiti","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","North Korea","South Korea","Kuwait","Kosovo","Lao People's Democratic Republic","Kyrgyzstan","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macedonia, The Former Yugoslav Republic of","Madagascar","Malawi","Malaysia", "Maldives", "Mali","Malta",  "Marshall Islands",  "Mauritania",  "Mauritius", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco",  "Mongolia",  "Montenegro", "Morocco", "Mozambique", "Myanmar","Namibia", "Nauru", "Nepal", "Netherlands",  "New Zealand", "Nicaragua", "Niger",  "Nigeria","Norway","North Macedonia", "Oman",  "Pakistan",  "Palau",  "Palestinian Territories",  "Panama",  "Papua New Guinea",  "Paraguay",  "Peru",  "Philippines",  "Poland",  "Portugal",  "Qatar",  "Romania",  "Russia",  "Rwanda",  "Saint Kitts and Nevis",  "Saint Lucia",  "Samoa",  "San Marino",  "Sao Tome and Principe",  "Saudi Arabia",  "Senegal",  "Serbia",  "Seychelles",  "Sierra Leone",  "Singapore",  "Slovakia",  "Slovenia",  "Solomon Islands",  "Somalia",  "South Africa",  "Spain",  "Sri Lanka",  "Scotland",  "Sudan",  "South Sudan",  "Suriname",  "Swaziland",  "Sweden", "Switzerland",  "Syrian Arab Republic",  "Taiwan (ROC)",  "Tajikistan",  "Tanzania",  "Thailand",  "Timor-leste",  "Togo",  "Tokelau",  "Republic of Somaliland",  "Somaliland",  "Tonga",  "Trinidad and Tobago",  "Tunisia",  "Turkey",  "Turkmenistan",  "Uganda",  "Ukraine",  "United Arab Emirates",  "United Kingdom",  "United States",  "Uruguay",  "Uzbekistan",  "Vanuatu",  "Venezuela",  "Viet Nam",  "Yemen",  "Zambia",  "Zimbabwe",  "International Observer",  "Ambassador",  "Diplomatic Experts",  "Local Team Registration Members",  "Ambassadors",  "Speakers and Guest of Honours",  "International Observers",  "Volunteers",  "Shell PLC",  "Greenpeace",  "Chevron",  "Exxon",  "British Petroleum",  "Gazprom",  "Coal India",  "Saudi Aramco",  "Total SA",  "Iraq national Oil Co.",  "Kuwait Petroleum Corp",  "Clean Air Fund",  "Majid Al Futtaim",  "Abu Dhabi National Oil (ADNOC)",  "YoungO",  "Amnesty International",  "CERES",  "Doctors without borders",  "Oxfam",  "Apple",  "Microsoft",  "Amazon",  "Facebook", "Google",  "YouTube",  "IBM",  "Open AI",  "Nvidia",  "EFF Electronic Frontier Foundation" ];
  // Check elements in uniqueAllEventSuspended that are not in allEventSuspend
  // console.log("total country ",uniqueAllEventSuspended.length);
  for (let i = 0; i < uniqueAllEventSuspended?.length; i++) {
    if (!allEventSuspend.includes(uniqueAllEventSuspended[i])) {
      newArray.push(uniqueAllEventSuspended[i]);
    }
  } // Check elements in allEventSuspend that are not in uniqueAllEventSuspended or already added to newArray
  for (let i = 0; i < allEventSuspend.length-1; i++) {
    if (!uniqueAllEventSuspended.includes(allEventSuspend[i]) && !newArray.includes(allEventSuspend[i])) {
      newArray.push(allEventSuspend[i]);
    }
  
  }



  let arrayOfNationalities = [];


  
useEffect(() => {
            newArray?.forEach((item) =>
              arrayOfNationalities.push({ Country: item })
              );
              setNationalitiesToCsv(arrayOfNationalities);
              // console.log(mySet);
             
              // console.log(newArray);
            }, [])
           
          


            const handleDownloadAccommodation = () => {
             
              const newData = newArray?.map((item) => ({
                Countries :item,
               }));
          
              const csv = Papa.unparse(newData);
              const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute("download", "Available Countries.csv");
              document.body.appendChild(link);
              link.click();
            };
  
  return (<>
    <div classNames="pt-4">
      <nav className=" px-2 h-12  banner-back rounded-md flex items-center justify-between ">
        <div className=" px-2 gap-2  rounded-md flex items-center  ">
        {currentNavigationOperationHotelMember.map((item, index) => (
          <Link
            key={item.name}
            to={item.href}
            className={classNames(
              item.current
                ? "bg-red-700 border-blue-700 text-white hover:bg-red-600 hover:text-white"
                : "border-transparent text-white hover:bg-red-600 hover:text-white",
              "group flex items-center rounded-md px-3 py-2 text-sm font-medium"
            )}
            onClick={() => handleClickNavigationHotelMember(index, setCurrentNavigationOperationHotelMember)}
          >
            {item.name}
          </Link>
        ))}
        </div>
        <div className="flex justify-between items-center gap-2">
          <div>
            <button onClick={() => {
                 setOnNtionality(true);
              }} className=" group flex items-center rounded-md px-3 py-2 hover:bg-red-600 hover:text-white text-sm font-medium border-blue-700 text-white ">Available Countries</button>
          </div>
          <div>
          {currentNavigationInsight.map((item, index) => (
          <Link
            key={item.name}
            to={item.href}
            className="bg-red-600 group flex items-center rounded-md px-3 py-2 hover:bg-red-600 hover:text-white text-sm font-medium border-blue-700 text-white "
              //   : "border-transparent text-white hover:bg-red-600 hover:text-white",
              // "group flex items-center rounded-md px-3 py-2 text-sm font-medium"
          
            onClick={() => handleClickNavigationinsight(index)}
          >
            {item.name}
          </Link>
        ))}
          </div>
      
        </div>
      </nav>
      <Routes>
        <Route path="all-registrations/:eventID" element={<Registration data={newArray}  />} />
        <Route path="guests/:eventID" element={<Guests />} />
        <Route path="observers/:eventID" element={<Observers />} />
        <Route path="core-team-member/:eventID" element={<CoreTeamMember />} />
        <Route path="analytics/:eventID" element={<Analytics />} />
        <Route
          path="local-team-member/:eventID"
          element={<LocalTeamMember />}
        />
      </Routes>
    </div>
          {/* nationalty for Filters */}
          <Transition.Root show={onNtionality} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOnNtionality}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                      <div className="flex-1">
                        {/* Header */}
                        <div className=" banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg flex gap-2 font-medium text-white">
                                <span>  Available Countries  ( <span>{newArray.length}</span> ) </span>{" "}
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-gray-400 hover:text-gray-500"
                                onClick={() => {
                                  setOnNtionality(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="list-decimal ml-6 space-y-1 divide-y text-gray-800  list-inside  dark:text-gray-800">
                       
                           <div className=" py-4 text-sm flex flex-wrap gap-2  px-2 text-gray-500">
                        {newArray?.map((items, index) => (
                          <span
                            key={index}
                            className="rounded-full border-2 border-gray-200 bg-gray-100 px-3 text-gray-600 text-xs font-semibold leading-5"
                          >
                            {items}
                          </span>
                        ))}
                      </div>
                        </div>
                      </div>
                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <div onClick={()=>{
                            handleDownloadAccommodation()
                          }} className="ml-3 cursor-pointer  inline-flex justify-center gap-1 rounded-md border border-transparent bg-red-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            {/* <ExportCSV
                              data={nationalitiesToCsv}
                              name={"Download CSV"}
                              fileName={`nationality-${eventID}`}
                            /> */}
                        Download CSV
                          </div>
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnNtionality(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default RegistrationdNavBar;
